import { NavBar, NavBarItem } from '@audio-network/componentlibrary'

import { sendAnalytics } from '@audio-network/analytics'
import styles from './LoggedOutActions.module.css'
import { useTranslation } from 'next-i18next'

const LoggedOutActions = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<NavBar>
			<NavBarItem
				className={styles.login}
				content={t('log-in')}
				href="/login"
				onClick={() => handleClick('Login')}
			/>
			<NavBarItem
				className={styles.registration}
				contained
				content={t('create-account')}
				href="/registration"
				onClick={() => handleClick('Registration')}
			/>
		</NavBar>
	)
}

export default LoggedOutActions
